<template>
  <div>
    <!-- <nav-bar></nav-bar> -->
    <div class="login_tit">
       <img src="../../assets/image/xf_vue_index.jpg" hight="100px" width="100px" alt="center">
    </div>
    <div class="form-container">
        <div class="menu-wrap">
            <div class="menu-wrap-title">基本信息</div>
            <van-field 
                required
				readonly 
                label="姓名" 
                placeholder="请输入姓名"  
                v-model="form.name"
                maxlength="10"
                v-validate="'required'"
                name="姓名"
                :error-message="errors.first('姓名')"
            />
            <van-field 
                v-model="form.sex"
                name="性别" 
                label="性别" 
                required 
                v-validate="'required'"
                :error-message="errors.first('性别')"
            >
                <template #input>
                    <van-radio-group v-model="form.sex" direction="horizontal">
                        <van-radio name="1">男</van-radio>
                        <van-radio name="2" class="form-radio">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field 
                required
                label="籍贯" 
                placeholder="请输入籍贯"  
                v-model="form.hometown"
                maxlength="10"
                v-validate="'required'"
                name="籍贯"
                :error-message="errors.first('籍贯')"
            />
            <!--van-field 
                required
                label="邮箱" 
                placeholder="请输入邮箱"
                v-model="form.mail"
                maxlength="32"
                v-validate="'required|mail'"
                name="邮箱"
                :error-message="errors.first('邮箱')"
            /-->
            <van-field 
                required
                label="民族" 
                placeholder="请输入民族"  
                v-model="form.nation"
                maxlength="20"
                v-validate="'required'"
                name="民族"
                :error-message="errors.first('民族')"
            />
            <van-field 
                required
                readonly
                label="出生年月" 
                placeholder="请选择出生年月" 
                v-model="form.birth" 
                @click="birthPop=true"
                v-validate="'required'"
                name="出生年月"
                :error-message="errors.first('出生年月')"
            />
            <van-field 
                required
                readonly
                label="文化程度" 
                placeholder="请选择文化程度" 
                v-model="form.education" 
                @click="singleClick('education','文化程度')"
                v-validate="'required'"
                name="文化程度"
                :error-message="errors.first('文化程度')"
            />
           <!--  <div class="uploader-wrap">
                <van-field label="本人照片" :border="false" label-width="220px" readonly/>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList" :max-count="1" :after-read="afterRead" @delete="imageDelete"></van-uploader>
            </div> -->
            <div class="uploader-wrap">
                <van-field required label="免冠寸照" :border="false" label-width="220px" readonly/>
                <div style="font-size: 12px;width: 5em;margin:-10px 0 0 15px ;line-height: 15px;text-align: center;color: #b2b2b2">注:图片不能超过2M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList" :max-count="1" :after-read="afterRead" @delete="imageDelete">
                </van-uploader>
            </div>
            <van-field 
                required
                readonly
                label="应聘岗位" 
                placeholder="请选择应聘岗位" 
                v-model="form.position" 
                @click="singleClick('position','应聘岗位')"
                v-validate="'required'"
                name="应聘岗位"
                :error-message="errors.first('应聘岗位')"
            />
            <van-field 
                required
                readonly
                label="报名身份" 
                placeholder="请选择报名身份" 
                v-model="form.former_name" 
                @click="singleClick('former_name','报名身份')"
                v-validate="'required'"
                name="报名身份"
                :error-message="errors.first('报名身份')"
            />
            <van-field 
                v-model="form.married"
                name="婚姻状况" 
                label="婚姻状况" 
                required 
                v-validate="'required'"
                :error-message="errors.first('婚姻状况')"
            >
                <template #input>
                    <van-radio-group v-model="form.married" direction="horizontal">
                        <van-radio name="已婚">已婚</van-radio> 
                        <van-radio name="未婚">未婚</van-radio>                    
                        <van-radio name="离异">离异</van-radio>
						<van-radio name="丧偶">丧偶</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field 
                required
                label="手机号码" 
                placeholder="请输入手机号码" 
                type="tel" 
                v-model="form.mobile"
                maxlength="11"
                v-validate="'required|mobile'"
                name="手机号码"
                :error-message="errors.first('手机号码')"
            />
            <van-field 
                required
                readonly
                label="政治面貌" 
                placeholder="请选择政治面貌" 
                v-model="form.politics" 
                @click="singleClick('politics','政治面貌')"
                v-validate="'required'"
                name="政治面貌"
                :error-message="errors.first('政治面貌')"
            />
			<van-field
			    readonly
			    label="入党时间" 
			    placeholder="入党/团时间 2021-07" 
			    v-model="form.commun_time" 
			    @click="yearsPopClick('commun_time','选择何时入党')"
			/>
			<van-field
			    required
			    label="宗教信仰" 
			    placeholder="如没有，请填写“无”"  
			    v-model="form.religions"
			    maxlength="20"
			    v-validate="'required'"
			    name="宗教"
			    :error-message="errors.first('宗教')"
			/>
            <van-field 
                readonly
                label="身份证号" 
                placeholder="请输入身份证号码"  
                v-model="form.idcard"
                maxlength="18"
                v-validate="'required|idcard'"
                name="身份证"
                :error-message="errors.first('身份证')"
            />
            <div class="uploader-wrap">
                <div class="uploader-text-wrap">
                <van-field required label="身份证" :border="false" label-width="220px" readonly/>
                <div class="uploader-text">(正面)</div>
                <div class="uploader-text2">注:图片不能超过10M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList31" :max-count="1" :after-read="afteridcard_img_1" @delete="imageDelete51"></van-uploader>
                </div>
                <div class="uploader-text-wrap">
                <van-field required label="身份证" :border="false" label-width="220px" readonly/>
                <div class="uploader-text">(反面)</div>
                <div class="uploader-text2">注:图片不能超过10M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList32" :max-count="1" :after-read="afteridcard_img_2" @delete="imageDelete52"></van-uploader>
                </div>
            </div>
			<van-field
			    required
			    label="紧急电话" 
			    placeholder="紧急联系电话" 
			    type="tel" 
			    v-model="form.t_mobile"
			    maxlength="11"
			    v-validate="'required|mobile'"
			    name="紧急电话"
			    :error-message="errors.first('紧急电话')"
			/>
            <van-field 
                required
                readonly
                label="常住地址" 
                placeholder="请选择常住地址" 
                v-model="form.address" 
                @click="areaPopClick('address','选择常住地址')"
                v-validate="'required'"
                name="常住地址"
                :error-message="errors.first('常住地址')"
            />
            <van-field 
                required
                label="详细地址" 
                placeholder="请输入常住地址街道,小区,门牌号" 
                v-model="form.res_address"
                maxlength="30"
                v-validate="'required'"
                name="常住详细地址"
                :error-message="errors.first('常住详细地址')"
            />
			<van-field
			    required
			    readonly
			    label="户口地址" 
			    placeholder="请选择户口地址" 
			    v-model="form.hukou_address" 
			    @click="areaPopClick('hukou_address','选择户口地址')"
			    v-validate="'required'"
			    name="户口地址"
			    :error-message="errors.first('户口地址')"
			/>
			<van-field 
			    required
			    label="详细地址" 
			    placeholder="请输户口住地址街道,小区,门牌号" 
			    v-model="form.hukou_res_address"
			    maxlength="30"
			    v-validate="'required'"
			    name="户口详细地址"
			    :error-message="errors.first('户口详细地址')"
			/>
            <div class="uploader-wrap">
                <div class="uploader-text-wrap">
                <van-field label="户口本" :border="false" label-width="220px" readonly/>
                <div class="uploader-text">(首页)</div>
                <div class="uploader-text2">注:图片不能超过2M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList51" :max-count="1" :after-read="afterhukou_img_1" @delete="imageDelete31"></van-uploader>
                </div>
                <div class="uploader-text-wrap">
                <van-field label="户口本" :border="false" label-width="220px" readonly/>
                <div class="uploader-text">(本人页)</div>
                <div class="uploader-text2">注:图片不能超过2M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList52" :max-count="1" :after-read="afterhukou_img_2" @delete="imageDelete32"></van-uploader>
                </div>
            </div>
            <!-- <van-field 
                required
                label="邮编" 
                placeholder="请输入邮编" 
                v-model="form.postcode"
                maxlength="10"
                v-validate="'required'"
                name="邮编"
                :error-message="errors.first('邮编')"
            />
           <!--  <van-field 
                required
                readonly
                label="户籍地址" 
                placeholder="请选择户籍地址" 
                v-model="form.res_address" 
                @click="areaPopClick('res_address','选择户籍地址')"
                v-validate="'required'"
                name="户籍地址"
                :error-message="errors.first('户籍地址')"
            />
            <van-field 
                required
                label="户籍性质" 
                placeholder="请输入户籍性质" 
                v-model="form.res_stat"
                maxlength="10"
                v-validate="'required'"
                name="户籍性质"
                :error-message="errors.first('户籍性质')"
            /> -->
        </div>
        
        <div class="menu-wrap" v-for="(item,index) in addlist.eduNum" :key="'itema'+index">
            <div class="menu-wrap-title">
                <span>教育经历信息0{{index+1}}</span>
                <van-icon class="delete-icon" name="delete-o" @click="deleteClick('eduNum',index)" />
            </div>
            <van-field 
                readonly
                label="起始时间" 
                placeholder="请选择起始时间" 
                v-model="form.edu_startdate[index]" 
                @click="yearsPopClick('edu_startdate','选择起始时间',index)"
            />
            <van-field 
                readonly
                label="结束时间" 
                placeholder="请选择结束时间" 
                v-model="form.edu_enddate[index]" 
                @click="yearsPopClick('edu_enddate','选择结束时间',index)"
            />
            <van-field 
                label="学校名称" 
                placeholder="请输入学校名称" 
                v-model="form.school[index]"
                maxlength="20"
            />
            <van-field 
                label="专业名称" 
                placeholder="请输入专业名称" 
                v-model="form.major[index]"
                maxlength="20"
            />
            <van-field 
                label="证书名称" 
                placeholder="请输入证书名称" 
                v-model="form.certificate[index]"
                maxlength="20"
            />
        </div>
        <div class="menu-wrap menu-wrap-add" @click="addClick('eduNum')">
            <van-icon class="add-icon" name="add" />
            <span>新增教育经历</span>
        </div>
        <div class="menu-wrap" v-for="(item,index) in addlist.workNum" :key="'itemb'+index">
            <div class="menu-wrap-title">
                <span>工作经历信息0{{index+1}}</span>
                <van-icon class="delete-icon" name="delete-o" @click="deleteClick('workNum',index)" />
            </div>
            <van-field 
                readonly
                label="起始时间" 
                placeholder="请选择起始时间" 
                v-model="form.wk_startdate[index]" 
                @click="yearsPopClick('wk_startdate','选择起始时间',index)"
            />
            <van-field 
                readonly
                label="结束时间" 
                placeholder="请选择结束时间" 
                v-model="form.wk_enddate[index]" 
                @click="yearsPopClick('wk_enddate','选择结束时间',index)"
            />
            <van-field 
                label="单位名称" 
                placeholder="请输入单位名称" 
                v-model="form.company[index]"
                maxlength="20"
            />
            <van-field 
                label="部门职位" 
                placeholder="请输入部门职位" 
                v-model="form.department[index]"
                maxlength="20"
            />
        </div>
        <div class="menu-wrap menu-wrap-add" @click="addClick('workNum')">
            <van-icon class="add-icon" name="add" />
            <span>新增工作经历</span>
        </div>
        <div class="menu-wrap" v-for="(item,index) in addlist.familyNum" :key="'itemc'+index">
            <div class="menu-wrap-title">
                <span>家庭成员信息0{{index+1}}</span>
                <van-icon class="delete-icon" name="delete-o" @click="deleteClick('familyNum',index)" />
            </div>
            <van-field 
                label="姓名" 
                placeholder="请输入姓名" 
                v-model="form.f_name[index]"
                maxlength="10"
            />
            <van-field 
                label="关系" 
                placeholder="请输入关系" 
                v-model="form.relation[index]"
                maxlength="10"
            />
            <van-field 
                label="单位名称" 
                placeholder="请输入单位名称" 
                v-model="form.f_company[index]"
                maxlength="10"
            />
            <van-field 
                label="职位名称" 
                placeholder="请输入职位名称" 
                v-model="form.f_department[index]"
                maxlength="10"
            />
            <van-field 
                label="手机号码" 
                placeholder="请输入手机号码" 
                type="tel" 
                v-model="form.phone[index]"
                maxlength="11"
            />
            <van-field 
                label="备注信息" 
                placeholder="请输入备注" 
                v-model="form.other[index]"
                maxlength="10"
            />
        </div>
        <div class="menu-wrap menu-wrap-add" @click="addClick('familyNum')">
            <van-icon class="add-icon" name="add" />
            <span>新增家庭成员</span>
        </div>
        <div class="menu-wrap">
            <div class="menu-wrap-title">附件上传</div>
 <!--             <van-field 
                required
                readonly
                label="服役情况" 
                placeholder="请选择服役情况" 
                v-model="form.serve_army" 
                @click="singleClick('serve_army','服役情况')"
                v-validate="'required'"
                name="服役情况"
                :error-message="errors.first('服役情况')"
            />  -->
            <van-field 
                v-model="form.serve_army"
                name="服役情况" 
                label="服役情况" 
                required 
                v-validate="'required'"
                :error-message="errors.first('服役情况')"
            >
            <template #input>
                <van-radio-group v-model="form.serve_army" direction="horizontal">
                    <van-radio name="是">是</van-radio> 
                    <van-radio name="否">否</van-radio>                    
                </van-radio-group>
            </template>
            </van-field>          
            <van-field 
                label="服役单位" 
                placeholder="请输入服役单位"  
                type="textarea"
                rows="1"
                autosize
                v-model="form.declaration"
            />
            <van-field 
                label="奖惩情况" 
                placeholder="请输入奖惩情况"  
                type="textarea"
                rows="1"
                autosize
                v-model="form.reward_reproa"
            />
			<van-field
			    v-model="form.sex"
			    name="驾照级别" 
			    label="驾照级别" 
		
			    :error-message="errors.first('驾照级别')"
			>
			<template #input>
				<van-radio-group v-model="form.license_level" direction="horizontal">
					<van-radio name="B2">B2</van-radio>
					<van-radio name="A1">A1</van-radio>
					<van-radio name="A2">A2</van-radio>
					<van-radio name="无">无</van-radio>
				</van-radio-group>
			</template>
			</van-field>
            <div class="uploader-wrap">
                <van-field label="驾照" :border="false" label-width="220px" readonly/>
                <div style="font-size: 12px;width: 5em;margin:-10px 0 0 15px ;line-height: 15px;text-align: center;color: #b2b2b2">注:图片不能超过2M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList4" :max-count="1" :after-read="afterdrive_license_img" @delete="imageDelete4"></van-uploader>
            </div>
            <div class="uploader-wrap">
                <van-field required label="学历证件" :border="false" label-width="220px" readonly/>
                <div style="font-size: 12px;width: 5em;margin:-10px 0 0 15px ;line-height: 15px;text-align: center;color: #b2b2b2">注:图片不能超过10M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList6" :max-count="1" :after-read="afteredu_img" @delete="imageDelete6"></van-uploader>
            </div>
            <div class="uploader-wrap">
                <van-field label="退役证" :border="false" label-width="220px" readonly/>
                <div style="font-size: 12px;width: 5em;margin:-10px 0 0 15px ;line-height: 15px;text-align: center;color: #b2b2b2">注:图片不能超过2M</div>
                <van-uploader class="uploader-img" accept="image/*" v-model="fileList7" :max-count="1" :after-read="afterretire_img" @delete="imageDelete7"></van-uploader>
            </div>
			<div class="uploader-wrap">
			    <van-field label="其他附件1" :border="false" label-width="220px" readonly/>
			    <div style="font-size: 12px;width: 5em;margin:-10px 0 0 15px ;line-height: 15px;text-align: center;color: #b2b2b2">注:图片不能超过2M</div>
			    <van-uploader class="uploader-img" accept="image/*" v-model="fileList8" :max-count="1" :after-read="afterattach1_img" @delete="imageDelete8"></van-uploader>
			</div>
			<div class="uploader-wrap">
			    <van-field label="其他附件2" :border="false" label-width="220px" readonly/>
			    <div style="font-size: 12px;width: 5em;margin:-10px 0 0 15px ;line-height: 15px;text-align: center;color: #b2b2b2">注:图片不能超过2M</div>
			    <van-uploader class="uploader-img" accept="image/*" v-model="fileList9" :max-count="1" :after-read="afterattach2_img" @delete="imageDelete9"></van-uploader>
			</div>
        </div>
        <div class="checkbox-wrap">
            <van-checkbox v-model="agreeChecked">本人承诺以上所填情况真实有效，如与事实情况不符，本人将承担所有责任。</van-checkbox>
        </div>
        <div class="submit-btn-wrap">
            <van-button class="submit-btn" type="info" @click="submitForm" :disabled="subDisabled">{{submitData.text}}</van-button>
        </div>
    </div>
    <!-- 生日弹窗 -->
    <van-popup v-model="birthPop" position="bottom">
        <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择出生年月"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="birthPop= false" 
        @confirm="birthConfirm"
        />
    </van-popup>
    <!-- 年月 -->
    <van-popup v-model="yearsPop" position="bottom">
        <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :title="yearTitle"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="yearsCancel" 
        @confirm="yearsConfirm"
        />
    </van-popup>
    <!-- 地址弹窗 -->
    <van-popup v-model="areaPop" position="bottom">
      <van-area title="选择地址" :area-list="areaList" value="610000" @cancel="areaCancel" @confirm="areaConfirm"/>
    </van-popup>
    <van-popup v-model="singlePop" position="bottom">
      <van-picker
        :title="singlePopTitle"
        show-toolbar
        :columns="singleColumns"
        @confirm="singleConfirm"
        @cancel="singleCancel"
     />
    </van-popup>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import AreaList from '@/utils/Area';
import { getUserInfo, submitDinfo } from "@/api";
import {auth_data}  from "@/utils/auth";
export default {
    name: "Registration",
    components: {NavBar},
    data() {
        return {
            form:{
                name:this.$store.state.name,
                former_name:undefined,
                sex:undefined,
                birth:undefined,
                idcard: this.$store.state.idcard,
                idcard_img_1:undefined,
                idcard_img_2:undefined,
                hukou_img_1:undefined,
                hukou_img_2:undefined,
				hukou_address:undefined,
				hukou_res_address:undefined,
                drive_license_img:undefined,
                edu_img:undefined,
                retire_img:undefined,
				attach1_img:undefined,
				attach2_img:undefined,
                photo:undefined,
                nation:undefined,
                hometown:undefined,
                religions:undefined,
                married:undefined,
                education:undefined,
                //mail:undefined,
                mobile:this.$store.state.phone,
                politics:undefined,
                commun_time:undefined,
				t_mobile:undefined,
				license_level:undefined,
                health:undefined,
                address:undefined,
                postcode:undefined,
                res_address:undefined,
                //res_stat:undefined,
                edu_startdate:[],
                edu_enddate:[],
                school:[],
                major:[],
                certificate:[],
                wk_startdate:[],
                wk_enddate:[],
                company:[],
                department:[],
                f_name:[],
                relation:[],
                f_company:[],
                f_department:[],
                phone:[],
                other:[],
                serve_army:undefined,
                reward_reproa:undefined,
                declaration:undefined,
                position:undefined,
            },
            currentDate: new Date(),
            minDate: new Date(1920, 1, 1),
            maxDate: new Date(),
            birthPop:false,
            yearName:undefined,
            yearIndex:undefined,
            yearTitle:undefined,
            yearsPop:false,
            areaList:AreaList,
            areaPop:false,
            areaPopName:undefined,
            areaPopTitle:undefined,
            fileList: [],
            fileList31: [],
            fileList32: [],
            fileList4: [],
            fileList51: [],
            fileList52: [],
            fileList6: [],
            fileList7: [],
			fileList8: [],
			fileList9: [],
            submitData:{
                disabled:false,
                text:'提交'
            },
            addlist:{
                eduNum:3,
                workNum:3,
                familyNum:3,
            },
            singlePop:false,
            singleName:undefined,
            singlePopTitle:undefined,
            singleColumns:[],
            columnsList:{
                position:['灭火救援员','执勤车驾驶员'],
                former_name:['社会青年','应届毕业生','国家综合性消防队伍退出人员','解放军或武警退役人员','政府专职人员','企业专职人员'],
                education:['高中及同等学历','大专','本科','硕士研究生以上'],
                politics:['中共党员','中共预备党员','团员','群众']
            },
            subDisabled:true,
            agreeChecked:false,
            //apiurl:'https://devblx.jiaedian.net',
            apiurl:'http://117.35.181.18:8088',
        }
    },
    watch: {
        agreeChecked(val){
            this.disabledChange();
        },
        'submitData.disabled'(){
            this.disabledChange();
        }
    },
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'overflow: visible !important;')
    },
    created(){
      let that=this;
      that.getuserInfo();
    },
    methods: {
      getuserInfo(){
         let that=this;
		 var sign = auth_data(localStorage.getItem('userId'));
         let list={
           //user_id:localStorage.getItem('userId'),
		   sign:sign+localStorage.getItem('userId') //为保密user_id 从sign中33位开始拼接
         }
         getUserInfo(list).then(res=>{
         if(res.code==200){
            if(res.data.name) that.form.name=res.data.name;
            if(res.data.sex) that.form.sex=res.data.sex;
            if(res.data.hometown) that.form.hometown=res.data.hometown;
            if(res.data.nation) that.form.nation=res.data.nation;
            if(res.data.birth) that.form.birth=res.data.birth;
            if(res.data.education) that.form.education=res.data.education;
            if(res.data.position) that.form.position=res.data.position;
            if(res.data.serve_army) that.form.serve_army=res.data.serve_army; //服役情况
            if(res.data.declaration) that.form.declaration=res.data.declaration;//服役单位
            if(res.data.reward_reproa) that.form.reward_reproa=res.data.reward_reproa;//奖惩情况
			if(res.data.positionlist) {
				//console.log(this.columnsList.position)
				this.columnsList.position=res.data.positionlist;
			}
            //头像
            if(res.data.photo){
                that.form.photo=res.data.photo;
                that.fileList = [{url:res.data.photo}]; 
            }

            if(res.data.former_name) that.form.former_name=res.data.former_name;
            if(res.data.married) that.form.married=res.data.married;
            if(res.data.mobile) that.form.mobile = res.data.mobile;
            if(res.data.mail) that.form.mail     = res.data.mail;
            if(res.data.politics) that.form.politics = res.data.politics;
			if(res.data.commun_time) that.form.commun_time=res.data.commun_time; //入党时间 20220121添加
			if(res.data.t_mobile) that.form.t_mobile=res.data.t_mobile; //紧急联系电话 20220121添加
			if(res.data.license_level) that.form.license_level=res.data.license_level; //驾照级别 20220121添加
			if(res.data.religions) that.form.religions = res.data.religions; //宗教信仰 20220121添加
			if(res.data.idcard) that.form.idcard       = res.data.idcard; //身份证 20220121添加
            //身份证
            if(res.data.idcard_img_1) that.form.idcard_img_1=res.data.idcard_img_1;
            if(res.data.idcard_img_2) that.form.idcard_img_2=res.data.idcard_img_2;
            if(res.data.idcard_img_1) that.fileList31 = [{url:res.data.idcard_img_1}];
            if(res.data.idcard_img_2) that.fileList32 = [{url:res.data.idcard_img_2}];
            //常住地址
            if(res.data.address) that.form.address=res.data.address;
            if(res.data.res_address) that.form.res_address=res.data.res_address;
			//户口地址
			if(res.data.hukou_address) that.form.hukou_address=res.data.hukou_address;
			if(res.data.hukou_res_address) that.form.hukou_res_address=res.data.hukou_res_address;
            //户口
            that.form.hukou_img_1=res.data.hukou_img_1; 
            that.form.hukou_img_2=res.data.hukou_img_2;
            if(res.data.hukou_img_1) that.fileList51 = [{url:res.data.hukou_img_1}];
            if(res.data.hukou_img_2) that.fileList52 = [{url:res.data.hukou_img_2}];

            that.form.drive_license_img=res.data.drive_license_img; //驾照
            if(res.data.drive_license_img) that.fileList4 = [{url:res.data.drive_license_img}];
            that.form.edu_img=res.data.edu_img; //学历证
            if(res.data.edu_img) that.fileList6 = [{url:res.data.edu_img}];
            //that.form.retire_img=res.data.retire_img; //退役证
            if(res.data.retire_img) that.fileList7 = [{url:res.data.retire_img}];
			if(res.data.attach1_img) that.fileList8 = [{url:res.data.attach1_img}];
			if(res.data.attach2_img) that.fileList9 = [{url:res.data.attach2_img}];
            //console.log(res.data.photo);
          }
        })
        },
        disabledChange(){
            let that=this;
            if(!that.submitData.disabled && that.agreeChecked){
                that.subDisabled=false;
            }else{
                that.subDisabled=true;
            }
        },
        addClick(name){
            let that=this;
            if(that.addlist[name]<5){
                that.addlist[name]+=1;
            }else{
                that.$toast({
                  message: "最多添加5个！",
                })
            }
        },
        deleteClick(name,index){
            let that=this;
            let eduList=['edu_startdate','edu_enddate','school','major','certificate'];
            let workList=['wk_startdate','wk_enddate','company','department'];
            let familyList=['f_name','relation','f_company','f_department','phone','other'];    
            if(that.addlist[name]>1){
                if(name=='eduNum'){
                    eduList.map(res=>{
                        that.form[res].splice(index,1);
                    })
                }else if(name=='workNum'){
                    workList.map(res=>{
                        that.form[res].splice(index,1);
                    })
                }else if(name=='familyNum'){
                    familyList.map(res=>{
                        that.form[res].splice(index,1);
                    })
                }
                that.addlist[name]-=1;
            }else{
                that.$toast({
                  message: "至少填一组数据！",
                })
            }
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        areaPopClick(name,title){
            this.areaPopName=name;
            this.areaPopTitle=title;
            this.areaPop=true;
        },
        areaConfirm(value){
            this.form[this.areaPopName]=value[0].name+value[1].name+value[2].name;
            this.areaPop=false;
        },
        areaCancel(){
            this.areaPop=false;
            this.areaPopName=undefined;
            this.areaPopTitle=undefined;
        },
        birthConfirm(val){
            const d = new Date(val)
            const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate());
            this.form.birth=resDate;
            this.birthPop=false;
        },
        yearsPopClick(name,title,index){
            this.yearName=name;
            this.yearTitle=title;
            this.yearIndex=index;
            this.yearsPop=true;
        },
        yearsConfirm(val){
            let that=this;
            const d = new Date(val)
            const resDate = d.getFullYear() + '.' + this.p((d.getMonth() + 1));
            //console.log(resDate)
            if(that.yearIndex || that.yearIndex===0){
                that.form[that.yearName][that.yearIndex]=resDate;
            }else{
                that.form[that.yearName]=resDate;
            }
            this.yearsPop=false;
        },
        yearsCancel(){
            this.yearsPop=false;
            this.yearName=undefined;
            this.yearTitle=undefined;
            this.yearIndex=undefined;
        },
        p(s) {
            return s < 10 ? '0' + s : s
        },
        //头像图片上传
        //action 1:头像 2:政审扫描件 31:户口首页 32：户口本人页 4:驾照 51:身份证(正) 52:身份证(反) 6：学历证书 7:退出现役证
        afterRead: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url: this.apiurl+`/api/upload_Img.php?action=1&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.photo=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //idcard图片上传
        afteridcard_img_1: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=51&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.idcard_img_1=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //身份证反面上传
        afteridcard_img_2: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=52&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.idcard_img_2=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //户口反面上传
        afterhukou_img_1: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=31&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.hukou_img_1=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //户口反面上传
        afterhukou_img_2: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=32&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.hukou_img_2=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //驾照上传
        afterdrive_license_img: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=4&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.drive_license_img=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //学历上传
        afteredu_img: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=6&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.edu_img=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //退役证上传
        afterretire_img: function(file) {
            let that=this;
            let userId=localStorage.getItem('userId');
            const param = new FormData();
            param.append("file", file.file);
            this.$axios({
                method:'POST',
                url:this.apiurl+`/api/upload_Img.php?action=7&user_id=${userId}`,
                headers:{'Content-Type':'multipart/form-data'},
                data:param
            }).then(res=>{
                if(res.data.code==200){
                    that.form.retire_img=res.data.data;
                }else{
                    that.$toast({
                        message: res.data.msg,
                    })
                }
            }).catch(err=>{
                console.log(err)
            })
        },
		//附件1上传
		afterattach1_img: function(file) {
		    let that=this;
		    let userId=localStorage.getItem('userId');
		    const param = new FormData();
		    param.append("file", file.file);
		    this.$axios({
		        method:'POST',
		        url:this.apiurl+`/api/upload_Img.php?action=8&user_id=${userId}`,
		        headers:{'Content-Type':'multipart/form-data'},
		        data:param
		    }).then(res=>{
		        if(res.data.code==200){
		            that.form.attach1_img=res.data.data;
		        }else{
		            that.$toast({
		                message: res.data.msg,
		            })
		        }
		    }).catch(err=>{
		        console.log(err)
		    })
		},
		//附件2上传
		afterattach2_img: function(file) {
		    let that=this;
		    let userId=localStorage.getItem('userId');
		    const param = new FormData();
		    param.append("file", file.file);
		    this.$axios({
		        method:'POST',
		        url:this.apiurl+`/api/upload_Img.php?action=9&user_id=${userId}`,
		        headers:{'Content-Type':'multipart/form-data'},
		        data:param
		    }).then(res=>{
		        if(res.data.code==200){
		            that.form.attach2_img=res.data.data;
		        }else{
		            that.$toast({
		                message: res.data.msg,
		            })
		        }
		    }).catch(err=>{
		        console.log(err)
		    })
		},
        imageDelete(){
            this.form.photo=undefined;
        },
        imageDelete51(){
            this.form.idcard_img_1=undefined;
        },
        imageDelete52(){
            this.form.idcard_img_2=undefined;
        },
        imageDelete4(){
            this.form.drive_license_img=undefined;
        },
        imageDelete31(){
            this.form.hukou_img_1=undefined;
        },
        imageDelete32(){
            this.form.hukou_img_2=undefined;
        },
        imageDelete6(){
            this.form.edu_img=undefined;
        },
        imageDelete7(){
            this.form.retire_img=undefined;
        },
        imageDelete8(){
            this.form.attach1_img=undefined;
        },
        imageDelete9(){
            this.form.attach2_img=undefined;
        },
        submitForm(){
            let that=this;
            that.$validator.validateAll().then((result) => {
                if(result){
                    
                    let list=JSON.parse(JSON.stringify(that.form));
                    let arr=['edu_startdate','edu_enddate','school','major','certificate','wk_startdate','wk_enddate','company','department','f_name','relation','f_company','f_department','phone','other'];
                    let eduList=['edu_startdate','edu_enddate','school','major','certificate'];
                    let workList=['wk_startdate','wk_enddate','company','department'];
                    let familyList=['f_name','relation','f_company','f_department','phone','other'];
                    //console.log(that.form.photo);
                    console.log(that.form.serve_army);
                    if(that.form.photo==undefined){
                        that.$toast({
                          message: "未上传免冠寸照",
                        })
                    }else if(that.form.idcard_img_1==undefined){
                        that.$toast({
                          message: "未上传身份证正面照片",
                        })
                    }else if(that.form.idcard_img_2==undefined){
                        that.$toast({
                          message: "未上传身份证反面照片",
                        })
                    }else if(that.form.edu_img==undefined){
                        that.$toast({
                          message: "未上传学历证书照片",
                        })
                    }else if(that.form.retire_img==undefined && that.form.serve_army=="是"){
                        that.$toast({
                          message: "请上传退役证照片",
                        })
						 console.log("请上传退役证照片")
                    }else{
                        arr.map(res=>{
                            that.subRest(1);
                            let obj="";
                            let num;
                            if(eduList.indexOf(res)!=-1){
                                num=that.addlist.eduNum;
                            }else if(workList.indexOf(res)!=-1){
                                num=that.addlist.workNum;
                            }else if(familyList.indexOf(res)!=-1){
                                num=that.addlist.familyNum;
                            }

                            for(let i=0;i<num;i++){
                                list[res][i]=list[res][i]?(list[res][i]).replace(/\s+/g,""):list[res][i];
                                if(list[res][i] && list[res][i+1]){
                                    list[res][i]=list[res][i]+'|';
                                }else{
                                    list[res][i]?list[res][i]=list[res][i]:list[res][i]='|';
                                }  
                                obj+=list[res][i];
                            }
                            list[res]=obj;
                        })
                        this.$dialog.confirm({
                           message:'确定要提交的内容无误'
                        }).then(()=>{
                            //确认提交
                            submitDinfo(list).then(res=>{
                                if(res.code==200){
                                    that.$toast({
                                        message: "提交成功",
                                    })
                                    localStorage.setItem('Types','first_condidate');
                                    that.$router.push('/news');
                                }
                                that.subRest(2);
                            }).catch(err=>{
                                that.subRest(2);
                            })
                        }).catch(err=>{
                            //点击取消提交
                           subRest(2); 
                        })
                    }
                    subRest(2); 
                }else{
                    //console.log(errors);
                    that.$toast({
                        message: "缺少必填字段,请检查",
                    })
                }
            })
        },
        subRest(type){
            let that=this;
            if(type===1){
                that.submitData={
                    disabled:true,
                    text:'提交中...'
                }
            }else{
                that.submitData={
                    disabled:false,
                    text:'提交'
                }
            }
        },
        singleClick(name,title){
            this.singlePopTitle=title;
            this.singleName=name;
            this.singleColumns=this.columnsList[name];
            this.singlePop=true;
        },
        singleConfirm(val){
            let name=this.singleName;
            this.form[name]=val;
            this.singleCancel();
        },
        singleCancel(){
            this.singlePop=false;
            this.singlePopTitle=undefined;
            this.singleName=undefined;
            this.singleColumns=[];
        },
    }
}
</script>

<style scoped  lang="less">
  ::v-deep .van-cell{
    line-height: 30px!important;
    background: none!important;
  }
  ::v-deep .van-radio__label{
    line-height: 35px!important;
  }
  ::v-deep .van-cell__title{
    width: 4.2em !important;
    text-align: left;
  }
  .menu-wrap{
    padding:10px;
    // margin-bottom:30px;
    // border-radius: 10px;
    background: #fff;
    border-bottom:6px solid #efefef;
  }
  .menu-wrap-title{
      position: relative;
      font-weight: bold;
      line-height: 45px;
      border-bottom: 1px solid #ebedf0;
      padding-left: 20px;
      overflow: hidden;
  }
  .menu-wrap-title::before{
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    bottom: 16px;
    left: 10px;
    width: 3px;
    height: 15px;
    background: #1989fa;
  }
  .delete-icon{
    float: right;
    line-height: 45px;
    font-size: 16px;
    margin-right: 10px;
    color: #aaa;
  }
  .menu-wrap-add{
    line-height: 30px;
    span{
        color: 	#4682B4;
    }
  }
  .menu-wrap-add .add-icon{
    margin: 0 5px;
    line-height: 30px;
    font-size: 24px;
    color: #60DA53;
    vertical-align: middle;
  }
  .submit-btn-wrap{
    width: 100%;
    margin:50px 0 60px 0;
    text-align: center;
  }
  .submit-btn{
    width:90%;
    border-radius: 10px;
    margin:0 auto 70px auto;
  }
  .form-radio{
    margin-left:1rem;
  }
  .contract-wrap{
    background: #FFF;
  }
  .imgshow-wrap{
    display:flex;
    flex-wrap: wrap;
    background:#FFF;
    padding:30px;
  }
  ::v-deep .vant-image .van-image__img{
    border-radius: 10px;
  }
  .imgshow-main{
    width: 29.3%;
    margin:0 2% 20px 2%;
    position: relative;
  }
  .photo-upload{
    background-color: #f7f8fa;
    position: relative;
  }
  .photo-upload .upload-icon{
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .imgDelete{
    position:absolute;
    top:-12px;
    left:136px;
    // font-size:32px;
    color:#969799;
    border-radius: 100%;
  }
  .uploader-wrap{
      position: relative;
      min-height: 100px;
      .uploader-text-wrap{
        width:50%;
        position: relative;
      }
      .uploader-text{
        font-size: 12px;
        width: 5em;
        margin: -12px 10px 0px 20px;
        line-height: 15px;
        text-align: left;
      }
      .uploader-text2{
        font-size: 12px;
        width: 5em;
        margin:5px 0 0 10px ;
        line-height: 15px;
        text-align: center;
        color: #b2b2b2
      }
  }
  .uploader-wrap::after{
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .uploader-img{
    position:absolute;
    top:10px;
    left: 6em;
  }
  ::v-deep .uploader-img .van-uploader__upload{
    width: 70px !important;
    height: 70px !important;
    margin: 7px 0 !important;
  }
  .uploader-wrap{
    min-height: 100px;
    display: flex;
    flex-wrap: wrap;
  }
  ::v-deep .van-cell__title{
    // width: 5em !important;
    text-align: left;
  }
  .checkbox-wrap{
      font-size: 14px;
      padding:20px 20px 0 20px;
  }
  ::v-deep .checkbox-wrap{
      color: #1989fa;
      font-weight: bold;
      line-height: 25px;
      font-size: 12px;
  }
  .login_tit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_tit img{
  width : 100%;
}
</style>